module.exports = "//public.zight.com/packs/media/images/email-f4fa52e7e637821d0b729ab62b1cc8c7.svg";